import { DistanceToGradCtrl } from './distance-to-grad.controller';

export const DistanceToGradComponent = {
  controller: DistanceToGradCtrl,
  template: require('./distance-to-grad.html'),
};
